import React from 'react';

export function SmokerLevelsCard() {
  const smokerLevels = [
    {
      level: 'Beginner',
      image: 'https://highmind-bucket.s3.us-east-1.amazonaws.com/cdb53b7a8c7e4624a810c0d654ca03c8_Smoker_beginer.webp',
      color: '#8b5cf6',
      description: 'New to the scene'
    },
    {
      level: 'Casual',
      image: 'https://highmind-bucket.s3.us-east-1.amazonaws.com/e72017f33d1c480db1928ca3d7295de4_Smoker_Level_cas.webp',
      color: '#ef4444',
      description: 'Occasional user'
    },
    {
      level: 'Connoisseur',
      image: 'https://highmind-bucket.s3.us-east-1.amazonaws.com/3e1e13711dd441fcb7c34c155416ee69_Smoker_Level_con.webp',
      color: '#00d4aa',
      description: 'Experienced enthusiast'
    },
    {
      level: 'Stoner',
      image: 'https://highmind-bucket.s3.us-east-1.amazonaws.com/9084554e27d747188148530bc7899eee_Smoker_Level_Logo_Stoner.webp',
      color: '#4480ef',
      description: 'Daily devotee'
    }
  ];

  const isMobile = window.innerWidth <= 768;

  return (

      <><div style={{
          padding: isMobile ? '.2rem' : '.35rem',
          borderBottom: '1px solid #333'
      }}>

          <p style={{
              margin: '0.5rem 0 0 0',
              color: '#888',
              fontSize: isMobile ? '0.75rem' : '0.875rem'
          }}>
              🌿 Smoker Levels, Find your tribe
          </p>
      </div><div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
          gap: isMobile ? '1rem' : '0',
          padding: isMobile ? '1rem' : '1.25rem'
      }}>
              {smokerLevels.map(({ level, image, color, description }) => (
                  <div
                      key={level}
                      style={{
                          textAlign: 'center',
                          padding: isMobile ? '0.75rem' : '0.5rem',
                          transition: 'transform 0.2s ease',
                          cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-4px)';
                      } }
                      onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                      } }
                  >
                      <div style={{
                          width: isMobile ? '2rem' : '2.5rem',
                          height: isMobile ? '2rem' : '2.5rem',
                          margin: '0 auto 0.75rem',
                          border: `3px solid ${color}`,
                          borderRadius: '50%',
                          padding: '0.25rem',
                          backgroundColor: '#0a0a0a',
                          transition: 'all 0.3s ease'
                      }}>
                          <img
                              src={image}
                              alt={level}
                              style={{
                                  width: '100%',
                                  height: '100%',
                                  borderRadius: '50%',
                                  objectFit: 'cover'
                              }} />
                      </div>

                      <div style={{
                          color: color,
                          fontSize: isMobile ? '0.875rem' : '0.95rem',
                          fontWeight: '700',
                          marginBottom: '0.25rem',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em'
                      }}>
                          {level}
                      </div>
                  </div>
              ))}
          </div></>

    
  );
}

export default SmokerLevelsCard;